import { CONTENT_PUBLICATION_STATUS } from '@/consts';
import BaseEntity from '@/entities/BaseEntity';
import SourceProfile from '@/entities/SourceProfile';
import User from '@/entities/User';

export default class ContentGenerationItemPublication extends BaseEntity {
  id = null;
  user = null;
  source_profile = null;
  status = CONTENT_PUBLICATION_STATUS.SUCCESS;
  post_id = null;
  post_url = null;
  error_message = null;
  published_at = new Date();

  _entityFields = {
    user: User,
    source_profile: SourceProfile,
  };

  constructor(rawData) {
    super();

    if (rawData && rawData.published_at) {
      rawData.published_at = new Date(rawData.published_at);
    }

    this.updateWith(rawData);
  }

  get isSuccess() {
    return this.status === CONTENT_PUBLICATION_STATUS.SUCCESS;
  }

  get hasError() {
    return this.status === CONTENT_PUBLICATION_STATUS.ERROR;
  }

  get platformLabel() {
    const platform = this.source_profile?.platform;
    if (!platform) {
      return '';
    }

    return platform[0].toUpperCase() + platform.slice(1);
  }

  get link() {
    if (this.post_id) {
      return '/posts/' + this.post_id + '/original';
    }

    return this.post_url;
  }
}
